export enum ERROR_MESSAGES {
    DEFAULT = "Ocurrió un error al procesar la solicitud.",
    CARGAR = "Ocurrió un error al cargar los datos.",
    ELIMINAR = "Ocurrió un error al eliminar los datos.",
    GUARDADO = "Ocurrió un error al aplicar los cambios.",
    SUBIR_ARCHIVO = "Ocurrió un error al subir el archivo.",
    FIRMA = "La firma ingresada es incorrecta."
}